<template>
  <div class="home -mt-[90px] lt-md:-mt-[300px]">
    <!-- banner -->
    <BannerIndex />
    <div class="container-1600 relative pt-[40px]">
      <!-- 探索你的未来 -->
      <div>
        <div class="flex items-center justify-between">
          <Title>探索你的未来</Title>
          <div class="flex items-center lt-lg:hidden">
            <el-input
              v-model="search"
              class="search-input"
              prefix-icon="el-icon-search"
              placeholder="请输入职位名称或关键词"
            ></el-input>
            <div
              @click="handleSearch"
              class="flex h-[65px] cursor-pointer items-center rounded-r-full pl-[23px] pr-[29px]"
              style="background-color: #0089d2; color: #fff"
            >
              查看职位
              <Icon icon="bi:arrow-right" class="ml-[12px] inline-block text-[25px] transition-all" />
            </div>
          </div>
        </div>
        <div class="-mx-[16px] mt-[45px] flex lt-lg:flex-wrap">
          <PosViewCard2
            class="w-[50%] px-[16px] lt-lg:mb-[20px] lt-lg:w-full"
            v-for="item in recruitCate"
            :key="item.resmenu_id"
            :title="item.title"
            :to="item.url"
            :count="item.count"
          />
        </div>
      </div>
      <!-- 人才推荐、人才政策 -->
      <div class="mt-[87px]">
        <div class="mb-[40px] flex items-center justify-between">
          <Title>人才政策</Title>
          <router-link to="/talent-policy">
            <el-button round>查看更多<i class="el-icon-arrow-right"></i></el-button>
          </router-link>
        </div>
        <div class="-mx-[16px] flex lt-lg:flex-wrap">
          <TalentPolicyCard2
            class="mx-[16px] w-[50%] lt-lg:mb-[20px] lt-lg:w-full"
            :title="talentPolicyCate[0].title"
            :tid="talentPolicyCate[0].t_id"
            :articleList="talentPolicyList[0]"
            bg="zc-bg-0.jpg"
          ></TalentPolicyCard2>
          <TalentPolicyCard2
            class="mx-[16px] w-[50%] lt-lg:mb-[20px] lt-lg:w-full"
            :title="talentPolicyCate[1].title"
            :tid="talentPolicyCate[1].t_id"
            :articleList="talentPolicyList[1]"
            bg="zc-bg-1.jpg"
          ></TalentPolicyCard2>
        </div>
      </div>
      <!-- 风采一览 -->
      <div class="mt-[75px]">
        <div class="flex items-center justify-between">
          <Title>风采一览</Title>
          <router-link to="/list-img">
            <el-button round>查看更多<i class="el-icon-arrow-right"></i></el-button>
          </router-link>
        </div>
        <div class="img-gallery mt-[40px] flex">
          <div class="img-gallery-left">
            <div v-for="(item, index) in imgList.list.slice(0, 1)" :key="index">
              <ListImgCard :detail="item" />
            </div>
          </div>
          <div class="img-gallery-right flex flex-wrap">
            <div v-for="(item, index) in imgList.list.slice(1, 9)" :key="index">
              <ListImgCard :detail="item" />
            </div>
          </div>
        </div>
      </div>

      <!-- HR信箱 -->
      <!-- <HrMail /> -->
    </div>
  </div>
</template>

<script>
import { formatDate, fileDownload } from '@/utils/tool';
import BannerIndex from '@/components/BannerIndex.vue';
import Title from '@/components/Title.vue';
import { Icon } from '@iconify/vue2';
import PosViewCard2 from '@/components/PosViewCard2.vue';
import HrMail from '@/components/HrMail.vue';
import ListImgCard from '@/components/ListImgCard.vue';
import TalentPolicyCard2 from '@/components/TalentPolicyCard2.vue';

import { talentPolicyCate, talentPolicyList, imgList } from '@/api/article';
import router from '@/router';

export default {
  name: 'HomeView',
  components: {
    BannerIndex,
    Title,
    Icon,
    PosViewCard2,
    HrMail,
    ListImgCard,
    TalentPolicyCard2,
    router,
  },
  data() {
    return {
      search: '',
      talentPolicyCate: [
        {
          t_id: '',
          pid: '',
          title: '',
          sortid: '',
        },
        {},
        {},
      ],
      talentPolicyList: [],
      imgList: {
        list: [
          {
            image_id: '',
            title: '',
            pic: '',
            status: '',
            create_time: '',
            update_time: '',
            sortid: '',
            author: '',
          },
        ],
      },
    };
  },
  methods: {
    getData() {
      // 人才政策分类数据
      talentPolicyCate().then((res) => {
        const data = res.data.list;
        data.sort((a, b) => Number(a.sortid) - Number(b.sortid));
        this.talentPolicyCate = data;

        // 人才政策列表数据
        this.talentPolicyCate.map((item, index) => {
          talentPolicyList({ limit: 5, page: 1, t_id: item.t_id }).then((res) => {
            const data = res.data.rows;
            data.map((item) => {
              item.create_time = formatDate(item.create_time, 'YYYY-MM-DD');
              return item;
            });
            this.$set(this.talentPolicyList, index, data);
          });
        });
      });
      // 风采一览列表数据
      imgList({ limit: 11, page: 1 }).then((res) => {
        const data = res.data.list;
        data.map((item) => {
          item.create_time = formatDate(item.create_time, 'YYYY-MM-DD');
          return item;
        });
        this.imgList.list = data;
      });
    },
    // 搜索
    handleSearch() {
      if (!this.search) {
        this.$message.error('请输入职位名称或关键词');
        return;
      }
      this.$router.push({
        path: 'pos',
        query: { recruit_catagory_id: 4, search: this.search },
      });
    },
  },
  computed: {
    recruitCate() {
      return this.$store.state.recruitCate;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.search-input {
  width: 539px;
}
::v-deep .search-input .el-icon-search {
  font-size: 30px;
  line-height: 65px;
  padding-left: 15px;
}
::v-deep .search-input input {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  height: 65px;
  line-height: 65px;
  padding-left: 57px;
}

// 人才推荐
.rctj {
  background: url('@/assets/images/index-rctj-bg.jpg') no-repeat;
  background-size: cover;
}

// 人才政策
.steps {
  position: relative;

  :before {
    content: '';
    position: absolute;
    left: 0;
    top: 5px;
    transform: translateX(-50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #086bd6;
    z-index: 2;
    border: 2px solid #fff;
    outline: 1px solid #086bd6;
  }
}

// 风采一览

.img-gallery-left {
  width: 540px;
  margin-left: -7px;
  & > div {
    width: 100%;
    height: 389px;
    padding: 0 7px;
  }
}
.img-gallery-right {
  flex-grow: 1;
  margin-right: -7px;
  margin-bottom: -14px;
  & > div {
    width: 25%;
    padding: 0 7px;
    padding-bottom: 14px;
  }
}

@media screen and (max-width: 1024px) {
  .img-gallery {
    display: block;
  }
  .img-gallery-left {
    width: 100%;
    margin-left: 0;
    margin-bottom: 14px;
  }
  .img-gallery-right {
    display: block;
    width: 100%;
    margin-right: 0;
    & > div {
      width: 100%;
      height: 389px;
    }
  }
  // .img-gallery > div {
  //   display: block;
  //   height: 300px;
  //   margin-bottom: 20px;
  // }
}
</style>
